module.exports = __webpack_public_path__ + "static/img/music_shuiji.eb62fa39.png";